import React from 'react';

interface ArrowProps {
  size?: string | number;
  color?: string;
  fillOpacity?: number;
  direction: 'top' | 'bottom' | 'left' | 'right';
}

const Arrow = ({ size = '24', color = '#CE181E', fillOpacity = 1, direction }: ArrowProps) => {
  const getRotation = (direction: string) => {
    switch (direction) {
      case 'top':
        return '-rotate-90';
      case 'bottom':
        return 'rotate-90';
      case 'left':
        return 'rotate-180';
      default:
        return 'rotate-0';
    }
  };

  return (
    <div className="flex justify-start items-start">
      <div className={`${getRotation(direction)}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            fill={color}
            fillOpacity={fillOpacity}
            d="M10 16.346l-.891-.878 4.843-4.843H3.654v-1.25h10.298L9.109 4.532l.89-.878L16.347 10 10 16.346z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default Arrow;
